<template>
  <div class="self_c">
    <headNav :color="color" :title="window_c['Gift redemption']" :back="true" />
    <div id="integral" class="content self_b">
      <div class="cell-title-box">
        <p class="cell-integral">
          {{ window_c["Points"] }}
          <span class="cell-total self_color" v-text="total"></span>
        </p>
        <p class="cell-button self_bg_color" @click="toIntergralRecode">
          {{ window_c["Transaction record"] }}
        </p>
      </div>

      <!-- 搶購專區 -->

      <div v-for="(itm, idx) in list" :key="idx" class="cell-section">
        <h4 v-text="itm.groupName" class="cell-title"></h4>
        <div class="cell-box">
          <!-- item -->
          <div
            class="cell-item"
            :style="{ width: 100 / itm.cols - 2 + '%' }"
            @click="toDetails(item.id, item)"
            v-for="(item, index) in itm.productList"
            :key="index"
          >
            <!-- 图片 -->

            <van-image
              :height="
                (imgWidth * (!itm.height ? itm.height : 50)) /
                  (itm.cols == '1' ? 120 : 100)
              "
              width="100%"
              :src="item.imgUrl"
            >
              <template v-slot:error>
                <img
                  :style="
                    'width:100%;height:' +
                      (imgWidth * (!itm.height ? itm.height : 50)) /
                        (itm.cols == '1' ? 120 : 100) +
                      'px;'
                  "
                  src="../../assets/icon/small_default.png"
                />
              </template>
            </van-image>

            <!-- 描述 -->
            <div class="cell-desc self_bg_color">
              <p v-text="item.productName" class="cell-p ell1"></p>
              <p class="cell-price">
                <span v-text="item.points ? item.points : 0"></span>
                <span>{{ window_c["points"] }}</span>
              </p>
            </div>
            <!-- 優惠 -->
            <p
              v-if="item.saleType == '1' && item.statusVal == '1'"
              class="cell-status open-to-rob"
            >
              {{ item.saleBeginTime }}{{ window_c["Open up"] }}
            </p>
            <p
              v-else-if="item.saleType == '1' && item.statusVal == '2'"
              class="cell-status2"
            >
              <span>{{ window_c["Panic buying has ended"] }}</span>
            </p>
            <p
              v-else-if="item.saleType == '1' && item.statusVal == '3'"
              class="cell-status immediately"
            >
              {{ window_c["Snap up now"] }}
            </p>
            <p
              v-else-if="item.saleType == '1' && item.statusVal == '4'"
              class="cell-status"
            >
              {{ window_c["Sold out"] }}
            </p>
            <p
              v-else-if="item.saleType == '0' && item.statusVal == '4'"
              class="cell-status2"
            >
              {{ window_c["Sold out"] }}
            </p>
            <!-- 庫存 -->
            <!-- v-if="item.displayStock == '2'" -->
            <div
              class="cell-surplus self_bg_color"
              v-show="!(item.saleType == '1' && item.statusVal == '1')"
            >
              <p>{{ window_c["Surplus"] }}</p>
              <p>{{ item.stock ? item.stock : 0 }} {{ window_c["Portion"] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headNav from "@/components/headNav";
import { getProductInfoByBrandId } from "@/js/api";
import util from "@/js/util.js";
import lang_ from "@/js/locales";
export default {
  data() {
    return {
      window_c: {
        "Gift redemption": "積分換禮品",
        Points: "積分",
        "Transaction record": "積分記錄",
        "Sold out": "售罄",
        Loading: "加載中...",
        "There are 1": "優惠券",
        coupons: "張",
        points: "分",
        Surplus: "尚餘",
        "Redeem now": "立即兌換",
        "Insufficient points": "積分不足",
        "Open up": "開搶",
        "Panic buying has ended": "搶購已結束",
        Remaining: "剩餘",
        End: "結束",
        "Are you sure": "是否確認以",
        exchange: "兌換",
        "Warm reminder": "溫馨提示",
        "Snap up now": "立即搶購",
        Portion: "份"
      },
      // total: 0,//用戶積分
      total: sessionStorage.getItem("consumePoints"), //用戶積分
      list: [],
      imgWidth: 375,
      color: ""
    };
  },
  created() {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this, () => {
      this.getProductInfoByBrand();
      this.color = this.themeColor;
    });
    this.init_lang();
    // this.total = this.$route.params.s;
  },
  mounted() {
    this.imgWidth = util.getWindowInner().w;
  },
  methods: {
    init_lang() {
      var window_c = this.window_c;
      window_c["Gift redemption"] = lang_.t("Gift redemption");
      window_c["Points"] = lang_.t("Points");
      window_c["points"] = lang_.t("points");
      window_c["Transaction record"] = lang_.t("Transaction record");
      window_c["Sold out"] = lang_.t("Sold out");
      window_c["Loading"] = lang_.t("Loading");
      (window_c["There are 1"] = lang_.t("There are 1")),
        (window_c["Surplus"] = lang_.t("Surplus")),
        (window_c["Redeem now"] = lang_.t("Redeem now")),
        (window_c["Insufficient points"] = lang_.t("Insufficient points")),
        (window_c["Open up"] = lang_.t("Open up")),
        (window_c["Panic buying has ended"] = lang_.t(
          "Panic buying has ended"
        )),
        (window_c["Remaining"] = lang_.t("Remaining")),
        (window_c["End"] = lang_.t("End")),
        (window_c["Are you sure"] = lang_.t("Are you sure")),
        (window_c["exchange"] = lang_.t("exchange")),
        (window_c["Warm reminder"] = lang_.t("Warm reminder")),
        (window_c["Snap up now"] = lang_.t("Snap up now")),
        (window_c["Portion"] = lang_.t("Portion"));
    },
    toDetails(id, item) {
      //搶購已結束 / 已售罄 禁止跳轉
      if (
        (item.saleType == "1" && item.statusVal == "2") ||
        (item.saleType == "0" && item.statusVal == "4")
      ) {
        return;
      }
      let brandId = util.getBrandId(this);
      this.$router.push({
        name: "integral_details",
        params: {
          arg: util.setQueryParams([brandId, id, this.total])
        }
      });
    },
    toIntergralRecode() {
      this.$router.push({
        name: "integral_recode",
        params:{
          arg: this.$route.params.arg
        }
      });
    },
    getProductInfoByBrand() {
      var self = this;
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: self.window_c["Loading"]
      });
      getProductInfoByBrandId({
        brandId: util.getBrandId(this)
      }).then(res => {
        console.log(res);
        self.$toast.clear();
        if (res.code == "1") {
          this.list = res.data;
        }
      });
    },
    errorImg(img) {
      return util.errorImg(img);
    }
  },
  components: {
    headNav
  }
};
</script>
<style scoped>
#integral .van-button--mini {
  min-width: 65px;
}
</style>
<style scoped>
.content {
  padding-top: 46px;
}
.cell-title-box {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px 5px;
  font-size: 17px;
}
.cell-integral {
  color: #000;
}
.cell-total {
  color: #56ac9a;
  padding-left: 4px;
}
.cell-button {
  padding: 6px 20px;
  color: #fff;
  border-radius: 10px;
  background-color: #56ac9a;
}
.cell-button:active {
  opacity: 0.8;
}
.cell-section {
}
.cell-title {
  color: #4d4d4d;
  font-size: 20px;
  font-weight: bold;
  padding: 10px 0 10px 10px;
}
.cell-box {
  display: flex;
  /* justify-content: center; */
  flex-wrap: wrap;
}
.cell-item {
  width: 50%;
  margin: 0 1% 2% 1%;
  position: relative;
  color: #eee;
  font-size: 0;
}
.cell-desc {
  padding: 5px 10px;
  background-color: #56ac9a;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  margin: 0 !important;
}
.cell-p {
  font-size: 16px;
}
.cell-price {
  display: flex;
  align-items: center;
}
.cell-price span:first-child {
  font-size: 14px;
  font-weight: bold;
  margin-right: 4px;
  color: #fff;
}
.cell-price span:last-child {
  font-size: 16px;
}
.cell-status {
  background-color: #808080;
  font-size: 20px;
  height: 36px;
  line-height: 36px;
  letter-spacing: 2px;
  border-radius: 20px;
  padding: 0 10px;
  position: absolute;
  top: 20px;
  left: 20px;
}
.cell-status2 {
  font-size: 18px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cell-surplus {
  /* width: 60px; */
  /* 	min-width:60px;
	height: 60px; */
  position: absolute;
  right: 10px;
  top: 10px;
  text-align: center;
  padding: 5px;
  z-index: 99;
  background-color: #1db093;
  font-size: 16px;
}
.cell-surplus p {
  line-height: 1;
}
.cell-surplus p:last-child {
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
.immediately {
  background: yellow;
  color: #4a4a5a;
}
.open-to-rob {
  background: yellow;
  color: #4a4a5a;
  /* z-index: 2!important; */
}
</style>



// WEBPACK FOOTER //
// src/view/vipCard/integral.vue